module.exports = __webpack_public_path__ + "img/01.5d20b72a.png";